import { eventBus } from "@/eventBus.js";

const withLoader = message =>
  eventBus.$toasted.info(
    `${message} <img src='/static/loader-white.svg' height='20px' style='margin-left: 10px' />`,
    { duration: null }
  );

export default {
  withLoader
};



// WEBPACK FOOTER //
// ./src/utils/functions/toasted.js